import Box from '@mui/material/Box'
import type { ComponentType, ReactElement } from 'react'

import {
  KestrixNoticeErrorIcon,
  KestrixNoticeInfoIcon,
  KestrixNoticeSuccessIcon,
  KestrixNoticeWarningIcon
} from '../KestrixSvgIcons.jsx'
import type { NoticeBannerVariant } from './notice-banner-tokens.ts'
import { noticeBannerTokens as tokens } from './notice-banner-tokens.ts'

type SvgIconProps = {
  readonly size?: number
  readonly color?: string
  readonly sx?: object
}

const NOTICE_BANNER_ICONS: Record<
  NoticeBannerVariant,
  ComponentType<SvgIconProps>
> = {
  info: KestrixNoticeInfoIcon,
  warning: KestrixNoticeWarningIcon,
  success: KestrixNoticeSuccessIcon,
  error: KestrixNoticeErrorIcon
}

type NoticeBannerIconProps = {
  readonly variant: NoticeBannerVariant
  readonly color: string
}

const iconFrameSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: tokens.sizing.iconFrame,
  height: tokens.sizing.iconFrame,
  borderRadius: tokens.sizing.radius
} as const

/** 16px Kestrix outline glyph in a 24px frame. */
export const NoticeBannerIcon = ({
  variant,
  color
}: NoticeBannerIconProps): ReactElement => {
  const Icon = NOTICE_BANNER_ICONS[variant]

  return (
    <Box aria-hidden data-testid="kestrix-notice-banner-icon" sx={iconFrameSx}>
      <Icon
        size={tokens.sizing.icon}
        color={color}
        sx={{ display: 'block', overflow: 'visible' }}
      />
    </Box>
  )
}
